import React, { PropTypes } from 'react';
import { RaisedButton, FontIcon } from 'material-ui';
import GenericRightSideLayout from './right-side-layout';
import R, { or, not, prop, equals, call, cond, T } from 'ramda';
import { etoaIcon, ntaIcon } from './memberships-text';
import GetVerified from './../../get-verified';

const DisplayMemberships = props => {
  const {
    updateProps,
    isEditable,
    membershipsReducer,
    sortedMemberships,
    isSupplier,
  } = props;
  const generateExistingBadges = (isColoredIcon, name) => call(cond([
    [equals('National Tour Association (NTA)'), () => ntaIcon(isColoredIcon)],
    [equals('European Tourism Association (ETOA)'), () => etoaIcon(isColoredIcon)],
    [T, () => {
      return (
        <FontIcon
          className="tc-icon-hourglass_empty"
          color="rgba(0, 0, 0, 0.54)"
          style={{ fontSize: '26px', marginLeft: '-5px' }}
        />
      );
    }],
  ]), name);

  return (
    <GenericRightSideLayout
      isSupplier={isSupplier}
      leftColumnContentText="Industry Memberships / Organizations"
      rightColumnContentText={
        or(membershipsReducer.membershipsEditState, not(isEditable)) ? <span/> :
          <div style={{ marginRight: '10px' }}>
            {
              isSupplier ?
                <div style={{ color: '#00bcd4' }} onTouchTap={() => updateProps({ membershipsEditState: true })}>
                  <FontIcon
                    className="tc-icon-mode_edit profile-edit-icon"
                    color="#00bcd4"
                    style={{ fontSize: '14px' }}
                  />
                  &nbsp;EDIT
                </div>
                : <RaisedButton
                  label="Edit"
                  labelColor="#00bcd4"
                  labelStyle={{ top: '3px' }}
                  style={{ width: '8vw', height: '28px' }}
                  onTouchTap={() => updateProps({ membershipsEditState: true })}
                />
            }
          </div>
      }
      mainContent={
        <div style={{ margin: isSupplier ? '0 15px' : '' }}>
          {
            isEditable && !(sortedMemberships || []).find(({ badgeId }) => badgeId === '5ec074e495512b0156baf64f') && (
                <div key={0} className="Grid">
                  <div className="Grid-cell Grid--1of3 verified-member-block" style={{ maxWidth: '25%', wordWrap: 'break-word', margin: '5px 2% 0 0' }}>
                    <img src="https://s3.amazonaws.com/tourconnect_production/0000105302651/tc_verified.jpg" height="30px"/>
                  </div>
                  <div className="Grid-cell Grid--1of3 Grid-cell--center" style={{ maxWidth: isSupplier ? '55%' : '39%', wordWrap: 'break-word', marginRight: '2%' }}>
                    <p style={{ color: isSupplier ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.87)', fontSize: '14px' }}>TourConnect Verified</p>
                  </div>
                  <div className="Grid-cell Grid--1of3" style={{ wordWrap: 'break-word', margin: '5px 2% 0 0', textAlign: isSupplier ? 'right' : 'center' }}>
                    <GetVerified />
                  </div>
                </div>
              )
          }
          {
            sortedMemberships && sortedMemberships.length ?
              sortedMemberships.map((membership, index) => {
                if ((equals(membership.verifiedStatus, 'verified') && !isEditable) || isEditable) {
                  return (
                    <div key={index} className="Grid">
                      <div className="Grid-cell Grid--1of3 verified-member-block" style={{ maxWidth: '25%', wordWrap: 'break-word', margin: '5px 2% 0 0' }}>
                        {membership.logo && <img src={membership.logo} height={membership.name === 'European Tourism Association (ETOA)' ? '25px' : '30px'}/>}
                        {(isSupplier && membership.website) && <span className="what-is-org-hover">
                              What is <a href={prop('website', membership)} style={{ color: '#ff4081' }} target="_blank">{membership.acronym ? membership.acronym : membership.name}</a>?
                        </span>}
                      </div>
                      <div className="Grid-cell Grid--1of3 Grid-cell--center" style={{ maxWidth: isSupplier ? '55%' : '39%', wordWrap: 'break-word', marginRight: '2%' }}>
                        <p style={{ color: isSupplier ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.87)', fontSize: '14px' }}>{membership.name}</p>
                      </div>
                      <div className="Grid-cell Grid--1of3" style={{ maxWidth: isSupplier ? '10%' : '39%', wordWrap: 'break-word', margin: '5px 2% 0 0', textAlign: isSupplier ? 'right' : 'center' }}>
                        {{
                          verified: <span style={{ color: '#00bcd4' }}>Verified</span>,
                          rejected: <span style={{ color: '#ff4081' }}>Rejected</span>,
                        }[membership.verifiedStatus] || <span>Pending</span>}
                      </div>
                    </div>
                  );
                }
              }) :
              <div style={{ paddingBottom: '16px' }}>
                Did you know, a verified membership can get you to the top of our PartnerFinder search results? <br/>
                <a style={{ cursor: 'pointer' }} onClick={() => updateProps({ membershipsEditState: true })}>Add a membership now</a>
              </div>
          }
        </div>
      }
    />
  );
};

DisplayMemberships.propTypes = {
  updateProps: PropTypes.func,
  isEditable: PropTypes.bool,
  membershipsReducer: PropTypes.object,
  sortedMemberships: PropTypes.array,
  isSupplier: PropTypes.bool,
};

export default DisplayMemberships;



// WEBPACK FOOTER //
// ./src/app/components/profile/memberships/display-state.jsx